import { useState } from "react";
import { StatsBar } from "./StatsBar";
import { QueueList } from "./QueueList";
import { DetailPanel } from "./DetailPanel";

export function QueuePage() {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)]">
      <StatsBar />
      <div className="flex flex-1 min-h-0">
        <div className="w-2/5 min-w-[320px] max-w-[480px]">
          <QueueList selectedId={selectedId} onSelect={setSelectedId} />
        </div>
        <div className="flex-1">
          <DetailPanel itemId={selectedId} />
        </div>
      </div>
    </div>
  );
}
